import React from 'react';
import { Container, Typography, Box, ImageList, ImageListItem, ImageListItemBar } from '@mui/material';

// Import images
import image2025_ISMB from '../images/2025 ISMB.jpg';
import image2025_Teachers from '../images/2025 Teachers day.jpg';
import image2024_BIBM from '../images/2024 BIBM.jpg';
import image2024_Bioinformatics from '../images/2024 Bioinformatics.jpg';
import image2024_KCC from '../images/2024 KCC.jpg';
import image2024_KCC_2 from '../images/2024 KCC_2.jpg';
import image2024_KCC_3 from '../images/2024 KCC_3.jpg';
import image2024_KCC_4 from '../images/2024 KCC_4.jpg';
import image2023_KSC from '../images/2023 KSC.jpg';
import image2022_KCC from '../images/2022 KCC.jpg';
import image2025_MICCAI from '../images/2025 MICCAI.jpg';
import image2025_Bioinfo from '../images/2025 BIOINFO.jpg';
import image2025_KSC from '../images/2025 KSC.jpg';
import image2026_KCC from '../images/2026 KCC.jpg';
import image2026_ISMB from '../images/2026 ISMB.jpg';

const galleryImages = [
  { img: image2026_ISMB, title: '2026 ISMB @ Washington DC' },
  { img: image2026_KCC, title: '2026 KCC @ Jeju' },
  { img: image2025_KSC, title: '2025 KSC @ Yeosu' },
  { img: image2025_Bioinfo, title: '2025 BIOINFO @ Suwon' },
  { img: image2025_MICCAI, title: '2025 MICCAI @ Daejeon' },
  { img: image2025_ISMB, title: '2025 ISMB @ Liverpool' },
  { img: image2025_Teachers, title: '2025 Teachers day @ Wonju' },
  { img: image2024_BIBM, title: '2024 BIBM @ Lisbon' },
  { img: image2024_Bioinformatics, title: '2024 BIOINFO @ Gyeongju' },
  { img: image2024_KCC, title: '2024 KCC @ Jeju' },
  { img: image2024_KCC_2, title: '2024 KCC_2 @ Jeju' },
  { img: image2024_KCC_3, title: '2024 KCC_3 @ Jeju' },
  { img: image2024_KCC_4, title: '2024 KCC_4 @ Jeju' },
  { img: image2023_KSC, title: '2023 KSC @ Busan' },
  { img: image2022_KCC, title: '2022 KCC @ Jeju' },
];

// Group images by year
const imagesByYear = galleryImages.reduce((acc, image) => {
  const year = image.title.substring(0, 4);
  if (!acc[year]) {
    acc[year] = [];
  }
  acc[year].push(image);
  return acc;
}, {} as Record<string, typeof galleryImages>);

const Gallery: React.FC = () => {
  // Sort years in descending order
  const sortedYears = Object.keys(imagesByYear).sort((a, b) => parseInt(b) - parseInt(a));

  return (
    <Container>
      <Box sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom textAlign="center" sx={{ fontWeight: 'bold' }}>
          Gallery
        </Typography>
        <Typography variant="body1" textAlign="center" sx={{ mb: 6 }}>
          A glimpse into our lab's life and achievements.
        </Typography>
      </Box>

      {sortedYears.map(year => (
        <Box key={year} sx={{ mb: 6 }}>
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            {year}
          </Typography>
          <ImageList variant="masonry" cols={2} gap={8}>
            {imagesByYear[year].map((item) => (
              <ImageListItem key={item.img}>
                <img
                  src={`${item.img}?w=248&fit=crop&auto=format`}
                  srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                  alt={item.title}
                  loading="lazy"
                />
                <ImageListItemBar title={item.title} />
              </ImageListItem>
            ))}
          </ImageList>
        </Box>
      ))}
    </Container>
  );
};

export default Gallery;
